export default function (ctrl) {
	return function (response) {
		if (response && response.data && response.data.captcha) { // következő kérésnél már kell a kapcsa
			ctrl.captchaRequired = true;
			ctrl.$timeout(function () {
				ctrl.recaptcha.cbExpiration();
			}, 0);

		} else {
			ctrl.captchaRequired = false;
		}
	};
};
